// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__X_g9F","col":"CardReaderDesc_col__2gpl2","label":"CardReaderDesc_label__M1HO0"};